<template>
  <v-navigation-drawer v-model="drawer" absolute temporary>
    <!--persistent id="LeftDrawer" :mini-variant="miniVariant" :clipped="clipped" v-model="drawer" enable-resize-watcher :dark="$vuetify.dark" width="260" app fixed>             -->   
    <div id="left-scroll">      
      <v-img class="white--text" height="120px" :src="require('@/assets/img/bg/'+current_cover)">        
        <v-list-tile style="margin-top:55px" avatar @click="$router.push({path:'/profile'});">
          <v-list-tile-avatar :color="color">
            <img src="https://randomuser.me/api/portraits/men/85.jpg">
            <!--<img  v-if="avatar" :src="avatar" />
            <span v-else class="white--text headline">{{user.attr ? user.attr.name.charAt(0):'x'}}</span>-->            
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title class="title" style="color:#fff">{{user.attr? user.attr.name : 'john doe'}}</v-list-tile-title>
            <small class="light-green--text" v-if="online"><v-icon color="green lighten-2">fa-circle</v-icon> online</small>
            <small class="red--text" v-else><v-icon color="red">fa-circle</v-icon> offline</small>              
            <offline @detected-condition="handleConnectivityChange">
              <!-- Only renders when the device is online -->              
            </offline>            
          </v-list-tile-content>
        </v-list-tile>
      </v-img>      
    </div>        
  </v-navigation-drawer>
</template>
<script>
import config  from '@/config'  
import Muser   from '@/util/models/User';
import offline from 'v-offline';

let menu = require('@/router/navmenu');

export default {
  name: 'app-left-drawer',
  components: {
    offline
  },
  props: {
    expanded: {
      type: Boolean,
      default: true
    },
  },
  data: () => ({
    dialog: false,
    online : window.navigator.onLine,  
    title  : config.title,
    color  : config.color,
    username : null,
    miniVariant:false,
    clipped :false,
    mini: false,
    drawer: true,    
    orgns: [],
    scrollSettings: {
      maxScrollbarLength: 60
    },
    formModel :{
       user_id : null,       
    },
    Muser : Muser,
    user  : Muser.info(),
    avatar: Muser.info() && Muser.info().avatar? Muser.info().avatar:null,
    orgn_id : null,
    current_cover : '1.jpg',       
  }),  
  computed: {
    computeGroupActive () {
      return true;
    },    
    sideToolbarColor () {
      return this.$vuetify.options.extra.sideNav;
    },
    menus(){      
      return menu.default();
    }
  },
  created () {       
    this.getCover();
    window.getApp.$on('APP_LEFT_DRAWER_TOGGLED', () => {
      this.drawer = (!this.drawer);
    });
    window.getApp.$on('APP_LEFT_MINI_VARIANT', () => {
      this.miniVariant = (!this.miniVariant);
    });
    window.getApp.$on('APP_LEFT_CLIPPED', () => {
      this.clipped = (!this.clipped);
    });       
  },
  

  methods: {
    genChildTarget (item, subItem) {
      if (subItem.href) return;
      if (subItem.component) {
        return {
          name: subItem.component,
        };
      }
      if(!item.group){
        if(subItem.name){
          return { name: `${subItem.name}` };
        } else if(subItem.path){
          return { path: `${subItem.path}` };
        }
      }
      if(!subItem.name)
        return { name: `${item.group}` };
      return { name: `${item.group}/${(subItem.name)}` };
    },
    scrollHanle(/*evt*/) {
      
    },
    getCover(){
      var _  = require('lodash');
      var randomArray   = ['1.jpg','11.jpg', '12.jpg','13.jpg','14.jpg','16.jpg'];
      var randomElement = _.sample(randomArray);
      this.current_cover = randomElement;       
    },
    handleConnectivityChange(status) {
      this.online = status;
    },    
  }
};
</script>
<style lang="stylus">
  #left-scroll{
      height: calc(100vh - 64px);
      overflow: auto;
  }  
</style>
